import { render, staticRenderFns } from "./Mastercard.vue?vue&type=template&id=210bdc1e&"
import script from "./Mastercard.vue?vue&type=script&lang=js&"
export * from "./Mastercard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports